import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import ArrowIcon from "@/components/icons/arrow-icon";
import { EventRead, EventRequest } from "@/TS/Interfaces/global_interfaces";
interface InvitedListProps {
  event: EventRead;
  title: string;
  type: "requestsInProcess" | "requestsValidated";
  defaultMessage: string;
}

// Repli : `type="button"` requis car ce composant vit dans un <form>
// (sinon le bouton soumettrait la réunion).
function InvitedList(t0) {
  const $ = _c(20);
  const {
    event,
    title,
    type,
    defaultMessage
  } = t0;
  const [showRequests, setShowRequests] = useState(true);
  const requests = event[type as keyof EventRead] as Array<EventRequest>;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mt-6" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${title} (${requests.length})`;
  let t3;
  if ($[1] !== t2) {
    t3 = <p className="font-bold uppercase">{t2}</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== showRequests) {
    t4 = () => setShowRequests(!showRequests);
    $[3] = showRequests;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `transition-transform duration-200 ${!showRequests ? "rotate-180" : ""}`;
  let t6;
  if ($[5] !== t5) {
    t6 = <ArrowIcon size={20} className={t5} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t6) {
    t7 = <button type="button" onClick={t4} className="p-2 hover:bg-gray-100 rounded-full transition-colors">{t6}</button>;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t7) {
    t8 = <div className="flex justify-between items-center">{t3}{t7}</div>;
    $[10] = t3;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== defaultMessage || $[14] !== requests || $[15] !== showRequests) {
    t9 = showRequests && <>{requests.length > 0 ? <div className="flex flex-col mt-4 gap-5 md:gap-2 items-start">{requests.map(_temp)}</div> : <p className="text-sm text-gray-500">{defaultMessage}</p>}</>;
    $[13] = defaultMessage;
    $[14] = requests;
    $[15] = showRequests;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <div className="flex-1">{t1}{t8}{t9}</div>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}
function _temp(request, index) {
  return <div key={index} className="flex-1"><p className="font-bold h-fit">{request.firstName} {request.lastName}</p><p>{request.jobTitle}</p><p>{request.companyName}</p></div>;
}
export default InvitedList;